import axios from 'axios'
import interceptorSetup from './interceptors'

import * as auth from './auth'
import * as user from './user'
import * as account from './account'
import * as masterData from './masterData'
import * as masterDataLocation from './masterDataLocation'
import * as autocomplete from './autocomplete'
import * as order from './order'
import * as uploads from './uploads'
import * as masterDataCategory from './masterDataCategory'
import * as schedule from './schedule'
import * as shippingProblem from './shippingProblem'
import * as report from './report'
import * as transactions from './transactions'
import * as masterDataUserAdmin from './masterDataUserAdmin'
import * as notifications from './notifications'
import * as tax from './tax'
import * as basp from './basp'
import * as parameter from './parameter'

if (process.env.VUE_APP_API_TARGET === 'mock') {
  console.log('TCL: services index VUE_APP_API_TARGET', process.env.VUE_APP_API_TARGET)
  require(/* webpackChunkName: "mock-services" */ '../mock-services') // import mock adapter if env is mock
}

axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL
interceptorSetup()

export {
  auth,
  user,
  account,
  masterData,
  masterDataLocation,
  autocomplete,
  order,
  uploads,
  masterDataCategory,
  schedule,
  shippingProblem,
  report,
  transactions,
  masterDataUserAdmin,
  notifications,
  tax,
  basp,
  parameter
}
